export default __webpack_public_path__ + "static/media/what-is-rfund.534beca1.webp";